import React from 'react';
import Header from './Header';
import Hero from './Hero';
import ToolsShowcase from './ToolsShowcase';
import Features from './Features';
import HowItWorks from './HowItWorks';
import ComparisonTables from './ComparisonTables';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import FloatingShareButton from './FloatingShareButton';
import SEO from './SEO';
import { getWebsiteSchema, getOrganizationSchema, getFAQSchema } from '../utils/structuredData';
import './LandingPage.css';

const LandingPage = () => {
  // Combined structured data for the landing page
  const combinedStructuredData = [
    getWebsiteSchema(),
    getOrganizationSchema(),
    getFAQSchema()
  ];

  return (
    <div className="landing-page">
      <SEO
        title="Complete PDF Toolkit - Convert & Edit PDFs Online Free"
        description="Complete PDF toolkit with two powerful tools: convert any file to PDF or remove pages from existing PDFs. Supports 15+ formats, works entirely in your browser - no uploads, no registration required."
        keywords="PDF converter, PDF page remover, PDF editor, remove PDF pages, convert to PDF, online PDF tools, image to PDF, document to PDF, free PDF tools, browser PDF tools"
        url="/"
        type="website"
        structuredData={combinedStructuredData}
      />
      <Header />
      <main>
        <Hero />
        <ToolsShowcase />
        <Features />
        <ComparisonTables />
        <HowItWorks />
      </main>
      <Footer />
      <ScrollToTop />
      <FloatingShareButton />
    </div>
  );
};

export default LandingPage;